export const DIVIDER = '────────────';
export const DOTS = '...';
export const COMPONENT_ID = 'dropdown-list-component';
export const DEFAULT_VARIANT = 'dropDownContainer';
export const BORDERED = 'bordered';
export const FULL_WIDTH = 'fullWidth';
export const VARIANTS = [BORDERED];



// WEBPACK FOOTER //
// ./app/components/dropdown-list/constant.js